import { ConfigProvider } from "antd"
import React from "react"

import { antBreakpoints } from "../constants/breakpoint"
import { defaultTheme } from "../theme"
import { useAppearance } from "./use-appearance"

const PAPER_THEME = {
  ...defaultTheme,
  cssVar: true,
  inherit: false,
  token: { ...defaultTheme.token, ...antBreakpoints }
}

/**
 * Keeps a document light whatever the app's appearance: proposals, contracts,
 * PDFs, signing pages and outgoing email previews are read as white paper, and
 * their content is never recoloured. The viewer chrome around it still follows
 * the appearance.
 */
export function PaperSurface({
  children,
  className,
  style,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  const { resolved } = useAppearance()
  const paper = (
    <div
      {...rest}
      data-theme="light"
      className={className ? `ez-paper ${className}` : "ez-paper"}
      style={style}
    >
      {children}
    </div>
  )
  // Light keeps whatever providers the document is nested in; only dark needs
  // the paper's own, non-inheriting theme.
  if (resolved !== "dark") return paper
  return <ConfigProvider theme={PAPER_THEME}>{paper}</ConfigProvider>
}
